const C = {
  name: "ApiExplorer",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.02 2C6.80772 2 5.02 3.78772 5.02 6V9C5.02 10.1077 4.12772 11 3.02 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13C4.10772 13 5 13.8923 5 15V18C5 20.2123 6.78771 22 9 22H9.03C9.58228 22 10.03 21.5523 10.03 21C10.03 20.4477 9.58228 20 9.03 20H9C7.89228 20 7 19.1077 7 18V15C7 13.809 6.48186 12.741 5.65827 12.0088C6.49346 11.2762 7.02 10.2006 7.02 9V6C7.02 4.89228 7.91228 4 9.02 4C9.57228 4 10.02 3.55228 10.02 3C10.02 2.44772 9.57228 2 9.02 2Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.02 13H21.05C21.6023 13 22.05 12.5523 22.05 12C22.05 11.4477 21.6023 11 21.05 11C19.9423 11 19.05 10.1077 19.05 9V6C19.05 3.78772 17.2623 2 15.05 2H15.02C14.4677 2 14.02 2.44772 14.02 3C14.02 3.55228 14.4677 4 15.02 4H15.05C16.1577 4 17.05 4.89228 17.05 6V9C17.05 10.1886 17.5661 11.2547 18.3868 11.9868C17.5487 12.7195 17.02 13.797 17.02 15V18C17.02 19.1077 16.1277 20 15.02 20C14.4677 20 14.02 20.4477 14.02 21C14.02 21.5523 14.4677 22 15.02 22C17.2323 22 19.02 20.2123 19.02 18V15C19.02 13.8923 19.9123 13 21.02 13Z" />
    </svg>


  `
};
export {
  C as ApiExplorer
};
